import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { storeSession, getStoredToken, isTokenValid } from './auth/cognito';

// Handle Cognito token in URL hash BEFORE rendering
const hash = window.location.hash;
if (hash.includes('id_token=')) {
  const params = new URLSearchParams(hash.substring(1));
  const idToken = params.get('id_token');
  if (idToken) {
    storeSession(idToken);
    // Clear hash and redirect to dashboard
    window.history.replaceState({}, document.title, '/');
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);